module.exports = __webpack_public_path__ + "static/ranger-AYAGWW-699cbea710587c4e83e4cd55de0ce505.png";